import { useContext, createContext } from 'react';
export var SplitPanelContext = createContext({
    topOffset: 0,
    bottomOffset: 0,
    mainPanelWidth: 0,
    position: 'bottom',
    size: 0,
    getMaxWidth: function () { return 0; },
    getMaxHeight: function () { return 0; },
    isOpen: true,
    isMobile: false,
    splitPanelRef: undefined,
    onResize: function () { },
    onToggle: function () { },
    onPreferencesChange: function () { }
});
export function useSplitPanelContext() {
    return useContext(SplitPanelContext);
}
//# sourceMappingURL=split-panel-context.js.map